import { cn } from '@eliadmin/core/src/utils/style-utils';
import { BlogsSkeletonItem } from './blogs-skeleton-item';

export const BlogsSkeleton = () => {
  return (
    <div
      className={cn(
        'animate-pulse',
        'col-span-1 grid w-full grid-cols-1 gap-8 sm:col-span-2 sm:grid-cols-2 sm:gap-10 lg:gap-12',
      )}
    >
      <BlogsSkeletonItem />
      <BlogsSkeletonItem />
      <BlogsSkeletonItem />
      <BlogsSkeletonItem />
    </div>
  );
};
